const { radiansToDegrees } = require('../converter');

/**
 * Returns a given rotations for a width metrics objects
 * @param {Number[]} metrics - Metrics marking items width
 * @param {Number} r - Curve radius
 * @returns {Object}
 */
const getLettersRotation = (metrics, r) => metrics.reduce((data, width) => {
    const { total, rotations } = data;

    // Rotation is the angle created from the proportion between the letter width and a the curve radius
    const rotation = radiansToDegrees(width / r);

    return {
        total: total + rotation,

        // Item rotation is aggregated and centered
        rotations: [...rotations, total + (rotation / 2)]
    };
}, { total: 0, rotations: [] });

module.exports = getLettersRotation;
